import React from 'react';
import { Plus } from 'lucide-react';
import TaskCard from './TaskCard';

const columnConfig = {
  backlog: {
    title: 'Backlog',
    color: 'bg-slate-500',
    bgColor: 'bg-slate-50',
    borderColor: 'border-slate-200'
  },
  todo: {
    title: 'A Fazer',
    color: 'bg-blue-500',
    bgColor: 'bg-gradient-to-br from-blue-50 to-cyan-50',
    borderColor: 'border-blue-200'
  },
  in_progress: {
    title: 'Em Progresso',
    color: 'bg-amber-500',
    bgColor: 'bg-gradient-to-br from-amber-50 to-orange-50',
    borderColor: 'border-amber-200'
  },
  review: {
    title: 'Em Revisão',
    color: 'bg-purple-500',
    bgColor: 'bg-gradient-to-br from-purple-50 to-pink-50',
    borderColor: 'border-purple-200'
  },
  done: {
    title: 'Concluído',
    color: 'bg-emerald-500',
    bgColor: 'bg-gradient-to-br from-emerald-50 to-teal-50',
    borderColor: 'border-emerald-200'
  }
};

export default function KanbanColumn({
  status,
  tasks,
  onTaskClick,
  onAddTask,
  onHistoryClick,
  members = []
}) {
  const config = columnConfig[status] || columnConfig.backlog;

  const sortedTasks = [...tasks].sort(
    (a, b) => (a.order || 0) - (b.order || 0)
  );

  return (
    <div
      className={`flex-shrink-0 w-80 md:w-72 lg:w-80 flex flex-col
      ${config.bgColor} rounded-2xl border-2 ${config.borderColor}
      shadow-sm hover:shadow-md transition-all duration-300`}
    >
      {/* Header */}
      <div className="p-4 pb-2">
        <div className="flex items-center justify-between mb-1">
          <div className="flex items-center gap-2.5">
            <div
              className={`w-3 h-3 rounded-full ${config.color} shadow-md`}
            />
            <h2 className="font-bold text-slate-800 text-sm">
              {config.title}
            </h2>
            <span className="text-xs font-bold text-slate-500 bg-white/80 px-2.5 py-1 rounded-full shadow-sm">
              {tasks.length}
            </span>
          </div>

          <button
            className="h-8 w-8 flex items-center justify-center text-slate-400
            hover:text-blue-600 hover:bg-white/80 hover:shadow-md
            rounded-xl transition-all duration-200 hover:scale-110"
            onClick={() => onAddTask(status)}
          >
            <Plus className="w-4 h-4" />
          </button>
        </div>
      </div>

      {/* Task List */}
      <div
        className="
          flex-1 p-3 pt-1 min-h-[200px]
          max-h-[calc(100vh-220px)]
          overflow-y-auto overflow-x-hidden
        "
      >
        {sortedTasks.map((task:any) => (
          <TaskCard
            key={task.id}
            task={task}
            onClick={onTaskClick}
            onHistoryClick={onHistoryClick}
            members={members}
          />
        ))}

        {tasks.length === 0 && (
          <div className="flex flex-col items-center justify-center py-8 text-slate-400">
            <div className="w-14 h-14 rounded-2xl bg-white/80 flex items-center justify-center mb-3 shadow-sm border-2 border-dashed border-slate-200">
              <Plus className="w-6 h-6" />
            </div>
            <p className="text-xs font-medium">
              Adicione uma tarefa
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
